/**
 * WebSignPanel - Modern signature panel library
 * Entry point
 */

// Import Tailwind CSS
import './styles.css';

import { WebSignPanel } from './WebSignPanel.js';
import { XmlParser } from './utils/XmlParser.js';

// Panel version (injected at build time from package.json)
// eslint-disable-next-line no-undef
const VERSION = typeof __WSP_VERSION__ !== 'undefined' ? __WSP_VERSION__ : 'dev';
WebSignPanel.version = VERSION;

// Log version once when the library is loaded (helps identify the client's version)
console.info(`WebSignPanel v${VERSION}`);

// Add static methods to WebSignPanel for legacy XML conversion
WebSignPanel.fromLegacyXml = XmlParser.fromLegacyXml.bind(XmlParser);
WebSignPanel.toLegacyXml = XmlParser.toLegacyXml.bind(XmlParser);

// Export as named export only (better for UMD)
export { WebSignPanel };

// UMD global export
if (typeof window !== 'undefined') {
  window.WebSignPanel = WebSignPanel;
}
